import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Field, reduxForm } from 'redux-form'
import { Col, Row } from 'react-bootstrap'
import { get, find } from 'lodash'

import { Input } from 'Components/Form/Input'
import { Dropzone } from 'Components/Form/Dropzone'
import SubmitButton from 'Components/Form/SubmitButton'
import { SelectDashboard } from 'Components/Form/SelectDashboard'
import { SubmitButtonBlock } from 'Components/Form/SubmitButton/SubmitButtonBlock'
import { ContactDetailsWrapper } from 'Components/City/Form/Ambassador/ContactDetailsWrapper/index.js'

class AmbassadorContactDetailsForm extends PureComponent {
  render = (
    { ambassador, handleSubmit, citiesOptions, cities } = this.props,
  ) => (
    <form>
      <ContactDetailsWrapper>
        <Col xs={2}>
          <Col xs={3}>
            <Field
              component={Dropzone}
              name="profilePicture"
              src={ambassador.profilePicture}
            />
          </Col>
        </Col>
        <Col xs={10}>
          <Row>
            <Col xs={3}>
              <p className="col-title">Email Address</p>
              <p className="email">{ambassador.email}</p>
            </Col>
            <Col xs={3}>
              <p className="col-title">First Name</p>
              <Field name="firstName" id="firstName" component={Input} />
            </Col>
            <Col xs={3}>
              <p className="col-title">Last Name</p>
              <Field name="lastName" id="lastname" component={Input} />
            </Col>
          </Row>
          <Row>
            <Col xs={3}>
              <p className="col-title">Phone number</p>
              <Field component={Input} name="mobilePhone" id="mobilePhone" />
            </Col>
            {countrySearch(ambassador, cities) !== 'US' && (
              <Col xs={3}>
                <p className="col-title">
                  {businessNumberTitle(countrySearch(ambassador, cities))}--
                </p>
                <Field component={Input} name="abn" id="abn" />
              </Col>
            )}
          </Row>
          <Row>
            <Col xs={3}>
              <p className="col-title">City</p>
              <Field
                name="cityId"
                component={SelectDashboard}
                options={citiesOptions}
                props={{ sorted: true }}
              />
            </Col>
          </Row>
        </Col>
      </ContactDetailsWrapper>
      <Row>
        <SubmitButtonBlock>
          <SubmitButton value="Save" onClick={handleSubmit} />
        </SubmitButtonBlock>
      </Row>
    </form>
  )
}

const ambassadorById = state => state.ambassadors.ambassadorById
const findCityByName = (cities, ambassador) =>
  find(cities, ['name', get(ambassadorById(ambassador), 'city.name')])

export const countrySearch = (ambassador, cities) => {
  let country

  if (ambassador.id && cities.length > 0) {
    let city = cities.find(cities => ambassador.city.id === cities.id)
    country = city.country.countryCode
  }
  return country
}

export const businessNumberTitle = country => {
  switch (country) {
    case 'FR':
      return 'SIRET'
    case 'UK':
      return 'UTR'
    case 'AU':
      return 'ABN'
    default:
      return 'Business Number'
  }
}

AmbassadorContactDetailsForm.proptypes = {
  ambassador: PropTypes.object.isRequired,
  cities: PropTypes.array.isRequired,
}

const mapStateToProps = (state, initialProps) => ({
  initialValues: {
    firstName: get(ambassadorById(state), 'firstName'),
    lastName: get(ambassadorById(state), 'lastName'),
    cityId: get(findCityByName(initialProps.cities, state), 'id'),
    mobilePhone: get(ambassadorById(state), 'mobilePhone'),
    abn: get(ambassadorById(state), 'businessNumber'),
  },
  ambassador: ambassadorById(state),
  citiesOptions: initialProps.cities.map(c => ({ label: c.name, value: c.id })),
})

AmbassadorContactDetailsForm = reduxForm({
  form: 'ambassador-contact-details-form',
  enableReinitialize: true,
})(AmbassadorContactDetailsForm)

AmbassadorContactDetailsForm = connect(
  mapStateToProps,
  null,
)(AmbassadorContactDetailsForm)

export { AmbassadorContactDetailsForm }



// WEBPACK FOOTER //
// ./src/Containers/Form/City/Ambassador/ContactDetails/index.js